<div class="token-upload">

  <h4 class="title">{{ 'companies.form.ExternalToken.Title' | translate }}</h4>

  <div class="content">
    <mat-form-field>
      <mat-label *ngIf="isTokenExist">
        <ng-container *ngIf="isTokenCreatedNow; else displayTokenCreationDate">
          {{ 'companies.form.ExternalToken.CreateNow' | translate }}
        </ng-container>

        <ng-template #displayTokenCreationDate>
          {{ 'companies.form.ExternalToken.CreationDate' | translate }}
          {{ tokenCreationDate | date: "YYYY-MM-dd" }}
        </ng-template>
      </mat-label>
      <input placeholder="{{ 'companies.form.ExternalToken.TokenLabel' | translate }}"  matInput #token autocomplete="new-password"
             [type]="isShowToken ? 'text' : 'password'">
      <span class="generate-button" matSuffix (click)="generateToken()">
        {{ 'companies.form.ExternalToken.GenerateButton' | translate }}
      </span>
      <mat-icon matSuffix
                *ngIf="isTokenExist"
                color="primary"
                class="copy-token"
                (click)="copyToken()">{{ 'content_copy' }}
      </mat-icon>
      <mat-icon matSuffix
                class="show-password"
                (click)="showToken()">
        {{ isShowToken ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </mat-form-field>
  </div>

</div>
